import { useAuthContractAcceptMigrationMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import {
  ContractAcceptMigrationInputType,
  ContractAcceptMigrationResultType,
  UseContractAcceptMigrationType,
} from './types';

const useContractMigration = (): UseContractAcceptMigrationType => {
  const [mutation, mutationResult] = useAuthContractAcceptMigrationMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: ContractAcceptMigrationInputType) => {
    const mutationResult = await mutation({
      variables: { input },
    });

    return !!mutationResult.data?.contractAcceptMigration?.ok;
  };

  const response = mutationResult.data?.contractAcceptMigration;
  const resetResultData: ContractAcceptMigrationResultType['data'] = { ok: response?.ok };

  const result: ContractAcceptMigrationResultType = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    data: resetResultData,
  };

  return [request, result];
};

export default useContractMigration;
